<template>
  <div class="container">
    <h4>成功辅导以下学员进阶架构</h4>
    <ul class="list row">
      <li
          ref="item"
          class="item col-xl-2 col-lg-2 col-2"
          :class="{ active: active === index }"
          v-for="(item, index) in list"
          :key="index"
      >
        <div class="item-header" @click="change($event, index)">
          <img :src="item.activeIcon" v-if="active === index" alt=""/>
          <img :src="item.icon" v-else alt=""/>
          <div>
            <p class="title">{{ item.title }}</p>
            <p class="des" v-html="item.des"></p>
          </div>
        </div>
        <transition name="slide-fade">
          <div
              class="item-card"
              :style="{ left: -left + 'px' }"
              v-if="active === index"
          >
            <div class="item-card-area">
              <p class="area-title"><span>用户痛点</span></p>
              <div class="area-content">
                <p v-html="item.content.user"></p>
              </div>
            </div>
            <div class="item-card-area">
              <p class="area-title"><span>规划路线</span></p>
              <div class="area-content">
                <p v-for="(item, index) in item.content.line" :key="index">
                  {{ item }}
                </p>
              </div>
            </div>
            <div class="item-card-area">
              <p class="area-title"><span>就业</span></p>
              <div class="area-content row">
                <img
                    v-for="(previewItem, i) in item.content.previewList"
                    :key="i"
                    class="col-4 col-lg-4"
                    :src="previewItem.src"
                    alt=""
                    @click="onPreview(item.content.previewList, previewItem, i)"
                />
              </div>
            </div>
            <div class="item-card-btn">
              <button>更多喜报和成功案例</button>
            </div>
          </div>
        </transition>
      </li>
    </ul>
    <div class="preview" v-show="preview">
      <!-- <h3>3月份刚找的工作，靠刷算法，涨薪6k</h3> -->
      <div class="preview-content">
        <a href="javascript:;" class="prev" @click="onPreviewPrev">
          <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-left"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
            />
          </svg>
        </a>
        <img
            @click="onPreviewClose"
            class="preview-img"
            :src="previewState.src"
            style=""
        />
        <a href="javascript:;" class="next" @click="onPreviewNext">
          <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </a>
      </div>
      <h4>
        <span>{{ previewState.index + 1 }}</span
        >/<span>{{ previewList.length }}</span>
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      left: 0,
      active: -1,
      preview: false,
      previewState: {
        index: 0,
        title: '',
        src: ''
      },
      previewList: [],
      list: [
        {
          icon: require('@/assets/mca-ico/icon-1.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-1.png'),
          title: '大/研学生',
          des: '适合冲刺大厂 <br /> 争取一个好的起点',
          content: {
            user: '适合冲刺大厂，争取一个好的起点，着重点在知识点深度和体系性上突破',
            line: [
              '适合按照7+1模块或者按照6+1+1模块进行学习',
              '关注计组，底层原理，算法，技术整合案例',
              '视具体个人进行专属规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1599200228732528.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1605866352457878.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1603446947486549.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-2.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-2.png'),
          title: '非计算机专业',
          des: '升入技术底层会有无力感、突破薪资瓶颈',
          content: {
            user: '深入技术底层会有无力感，难以突破薪资瓶颈，随着年龄增长会逐渐温水煮青蛙，职业生涯发展天生会有萎靡现象，需要尽早改变这一痛点，走好未来的路',
            line: [
              '适合按照2+2+1模块进行学习',
              '应有针对性的向深度探索，不能因为技术而技术，同时要抓住底层原理于具体技术栈的关联关系',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1592384158.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1599741615377236.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592384246.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-3.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-3.png'),
          title: '专科学历',
          des: '学历低更需要 <br /> 技术过硬',
          content: {
            user: '或多或少会因为学历使自己的起点略低，学历低更需要技术过硬，技术实力属于程序员的另一个学历',
            line:
                [
                  '适合按照6+2+1模块或者4+2+1模块进行学习',
                  '通过对技术的深度理解，同时通过课程弥补自身简历项目，业务短板，在综合素质上来提升自己的级别',
                  '视具体情况规划',
                ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1598441740275265.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1597999692175546.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/159963470184449.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-4.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-4.png'),
          title: '在职海归',
          des: '回国发展，技术栈上 <br /> 会有水土不服现象',
          content: {
            user: '回国发展，技术栈上会有水土不服现象，需要侧重本土技术生态特点，3+2+1或者4+2+1，视具体情况规划',
            line: [
              '适合按照2+2+1模块进行学习',
              '国内外一部分是存在技术栈生态差异的，首先要扩展本土化业务及技术实践能力',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/160273920139326.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1600326038157964.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592632944575266.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-5.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-5.png'),
          title: '常年外包',
          des: '外包不一定不好 <br /> 要看行业项目等因素',
          content: {
            user: '外包不一定不好，要看行业项目等因素，常见现象是发展不稳定，一般是银行周边项目或者政府项目，技术栈相对传统，不太容易进入互联网企业',
            line: [
              '适合按照4+2+1或者6+2模块进行学习',
              '不只是吸收互联网项目的经验，技术栈的扩展，同时关注传统项目到微服务到分布式的改造，能把控在传统与互联网项目之间实施改造，当下也是众多企业的缺口  ',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1606109408918060.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1604844247811293.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592384132.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-6.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-6.png'),
          title: '冲刺大厂',
          des: '大厂考核点在于算法和架构、设计及技术栈宽度和深度',
          content: {
            user: '大厂考核点在于算法和架构设计及技术栈宽度和深度，而且，原来公司的价值并非个人价值，很多学员在跳槽的时候往往高估了自己的水平，冲刺大厂需谨慎，稳中求胜',
            line: [
              '目前通过率很高的学习方案有7+1+1或者4+2+1',
              '学员冲刺大厂的成功案例很多，分享了很多面经，针对后来的学员我们会有针对性的去调整学习规划和路线',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1604048132306587.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1604034646577718.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1603864843193652.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-7.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-7.png'),
          title: '移居外企',
          des: '对算法和计组等基础 <br /> 学科知识非常看重',
          content: {
            user: '对国外大厂考核重点，国际技术趋势，国际一线大厂成功案例迷茫，急需调整学习方案和计划，做有针对性的提升',
            line: [
              '适合按照3+1或者2+1+1模块进行学习',
              '移居国家不同，技术氛围不同，学习路线更需要积极互动，进行规划',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1592383885.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1605163532645573.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1603966285658183.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-8.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-8.png'),
          title: '寻求转行',
          des: '理论加实践，能面试 <br /> 还得能上手工作',
          content: {
            user: '理论加实践，能面试还得能上手工作，架构师前置知识和项目驱动学习方式效果最好',
            line: [
              '适合按照2+3+2或者2+3+1模块进行学习',
              '在规划的时候优先考虑按照已有经验及赋能方向进行规划，保证价值最大化和最快获得收益',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/160569318648275.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1599200216564915.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1600053145442734.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-9.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-9.png'),
          title: '跳槽涨薪',
          des: '最为复杂 <br /> 跳槽未必就涨薪',
          content: {
            user: '最为复杂，跳槽未必就涨薪，有可能上家公司工资过高，自身能力与社会脱节，需要具体分析简历细节，视具体情况规划',
            line: [
              '学员诉求比较复杂，自身掌握能力，时间要求等，适合按照多种路线学习',
              '首先是评估自身价值和含金量，分析市场，站在理智，客观的角度做最有效率的计划和安排',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1606294070849539.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1605519907932859.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592384381.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-10.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-10.png'),
          title: '镀金充电',
          des: '开辟技术视野 <br /> 快速掌握流行技术',
          content: {
            user: '开辟技术视野，快速掌握流行技术，扩展未来热点技术，在宽度与深度上做具体明确的学习路线，视具体情况规划',
            line: [
              '构建知识体系，先宽后深的方式，需要具体沟通分析进行安排',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1605163532645573.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1604034646577718.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1603966246268042.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-11.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-11.png'),
          title: '合伙创业',
          des: '技术合伙人在技术 <br /> 视野上要足够宽',
          content: {
            user: '技术合伙人在技术视野上要足够宽，无论架构能力，大数据或AI等领域需要贡献一定价值，除学习规划外可以获得讲师团队协助，视具体情况规划',
            line: [
              '此类人群相对特殊，除了规划外，还需要进行相关的互动和辅助',
              '技术栈实力和综合能力要求极高，适合B+C或者C+D类型的具体规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1604646139770149.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1593589481366523.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1604470527929223.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-12.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-12.png'),
          title: '传统项目',
          des: '痛点在于没有实际的 <br /> 互联网项目经验',
          content: {
            user: '痛点在于没有实际的互联网项目经验，特点是具备一定的业务能力，优先提升重构项目能力，基础理论和传统项目改造升级能力',
            line: [
              '适合快速普适路线6+2模块或者1+4+2模块进行学习，针对不同的个人，着重点在增值增强能力，重构项目或者直接赋能互联网项目',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1600250753166260.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592384132.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592384056.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-13.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-13.png'),
          title: '急速复业',
          des: '多种原因暂定一段工作时间、需要短时间能获得offer',
          content: {
            user: '因多种原因暂停一段工作时间，需要短时间能获得offer，根据背景因素，优先着力在面试必问套餐上的复盘和锻炼，',
            line: [
              '适合按照5+1+1或者3+2+1模块进行学习，除了在技术栈，业务能力方面快速恢复及符合市场要求外，简历指导，注意空档期问题规避等',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1592632944575266.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1605074286752857.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1592906122699791.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-14.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-14.png'),
          title: '转岗提升',
          des: '无论转中间件，转大数据 、业务转技术还是技术转业务',
          content: {
            user: '无论转中间件，转大数据，业务转技术还是技术转业务，需要对应一套基础理论和落地实践作为支撑，往往有相关经验，但是被卡在知识体系完整度和个别技术点问题上',
            line: [
              '复杂度相对较高，会针对性的设计规划学习路线，通过研讨会的方式，录制讨论视频，同步学员',
              '规划必须严格，要和学员做细致沟通，保证转岗转行成功',
              '视具体情况规划',
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1602228842330032.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1600053145442734.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1599122112993933.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-15.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-15.png'),
          title: '大龄人才',
          des: '目前企业对大龄友好 <br /> 而且更关注对应的实力',
          content: {
            user: '目前企业对大龄友好，而且更关注对应的实力，尤其技术视野和经验，根据背景因素和大厂高级岗位面试重点，视具体情况规划 <br> 相应的结论是：需要具备符合年龄的技术宽度和/或深度',
            line: [
              '适合按照2+3+2或者2+2+3模块进行学习',
              '针对P7职级或者P8职级，根据企业合作和学员面经，做与时俱进的提升和规划',
              '视具体情况规划'
            ],
            previewList: [
              {src: '//mashibing.cn:8088/employmentimage/1598512544956898.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1598769160592193.jpg'},
              {src: '//mashibing.cn:8088/employmentimage/1598933199692008.jpg'},
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-16.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-16.png'),
          title: '大龄危机',
          des: '温水煮青蛙 <br /> 技术提升不多',
          content: {
            user: '',
            line: '',
            previewList: [
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-17.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-17.png'),
          title: '非JAVA语言',
          des: '无论python / php / go / .NET等 语言涉及后端',
          content: {
            user: '',
            line: '',
            previewList: [
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
            ]
          }
        },
        {
          icon: require('@/assets/mca-ico/icon-18.png'),
          activeIcon: require('@/assets/mca-ico/icon-active-18.png'),
          title: '开发爱好',
          des: '符合开发爱好者组件 <br /> 知识体系及深度探索',
          content: {
            user: '',
            line: '',
            previewList: [
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
              {

                src: 'http://www.mashibing.cn:8088/employmentimage/160317333341655.jpg'
              },
            ]
          }
        }
      ]
    }
  },
  methods: {
    change(e, i) {
      if(this.active === i) return this.active = -1;
      this.left = this.$refs['item'][i].offsetLeft
      this.active = i
    },
    mouseover(e, i){
      this.left = this.$refs['item'][i].offsetLeft
      this.active = i
    },
    mouseleave(e, i) {
      this.active = -1
    },
    onPreviewClose() {
      this.preview = false
    },
    onPreview(previewList, previewItem, i) {
      this.preview = true
      this.previewList = previewList
      this.previewState = {
        ...previewItem,
        index: i
      }
    },
    onPreviewNext() {
      let index = this.previewState.index
      if (this.previewList.length - 1 === index) {
        index = 0
      } else {
        index++
      }
      this.previewState = {
        ...this.previewList[index],
        index
      }
    },
    onPreviewPrev() {
      let index = this.previewState.index
      if (index === 0) {
        index = this.previewList.length - 1
      } else {
        index--
      }
      this.previewState = {
        ...this.previewList[index],
        index
      }
    }
  },
  // watch: {
  //   active: function (newVal, oldVal) {
  //     console.log('------', newVal, oldVal)
  //   }
  // }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

h4 {
  font-size: 24px;
  margin: 34px 0;
  font-weight: 700;
}

.list {
  position: relative;

  .item {
    position: static;

    &-header {
      text-align: center;
      margin-bottom: 25px;
      cursor: pointer;

      img {
        width: 70px !important;
        float: none;
      }

      p {
        width: 100%;
      }

      .des {
        line-height: 14px;
        font-size: 12px;
        color: #808080;
      }
    }

    &-card {
      padding: 40px;
      width: 1140px;
      border: 1px solid #f08232;
      text-align: left;
      margin-top: -5px;
      margin-bottom: 25px;
      box-sizing: border-box;
      position: relative;

      &-area {
        .area-title {
          font-weight: 500;
          font-size: 24px;
          margin-bottom: 24px;
          position: relative;

          span {
            position: relative;
            z-index: 1;
          }

          &::after {
            position: absolute;
            content: '';
            display: block;
            width: 47px;
            height: 6px;
            bottom: 3px;
            z-index: 0;
            background: linear-gradient(45deg, #f08232, #ffc093, transparent);
          }
        }

        .area-content {
          margin-bottom: 24px;

          img {
            cursor: zoom-in;
            margin-bottom: 12px;
            height: 194px;
            width: 333px;
          }
        }
      }

      &-btn {
        text-align: center;

        button {
          margin: 0 auto;
          background: #fe7a1c;
          color: #fff;
          outline: none;
          padding: 2px 12px;
          border-radius: 20px;
          box-shadow: 0px 4px 0px 1px #fef2e6;
        }
      }
    }

    &.active {
      .item-header {
        position: relative;

        &::before {
          position: absolute;
          content: '';
          display: block;
          width: 18px;
          height: 18px;
          transform: rotate(45deg);
          bottom: -29px;
          left: calc(50% - 9px);
          border-left: 1px solid #f08232;
          border-top: 1px solid #f08232;
          background: #fff;
          z-index: 1;
        }

        .title {
          color: #f08232;
        }
      }
    }
  }
}

.preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  text-align: center;
  z-index: 1;

  h3 {
    font-size: 28px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    margin: 14px 0;
  }

  .preview-content {
    position: relative;
    width: calc(100vw - 200px);
    height: calc(100vh - 100px);
    margin: 0 auto;
    display: flex;
    align-items: center;

    a {
      position: absolute;
      font-size: 80px;
      color: #fff;
      margin: 0 10px;
    }

    .prev {
      left: -100px;
    }

    .next {
      right: -100px;
    }

    .preview-img {
      width: auto;
      max-width: 100%;
      max-height: calc(100vh - 150px);
      margin: auto;
      cursor: zoom-out;
    }
  }

  h4 {
    font-size: 18px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    margin-top: 12px;
  }
}

// @media (min-width: 576px) {
//   .container {
//     width: 540px;
//   }
// }
// @media (min-width: 768px) {
//   .container {
//     width: 1140px;
//     max-width: 1140px;
//   }
// }
// @media (min-width: 992px) {
//   .list .item-card {
//     width: 960px;
//   }
// }
</style>
